export default {
      id: "replay-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#replay",
      toString: function () {
        return this.url;
      }
    }